<template>
    <v-dialog width="500px" :value="value" @input="toggleModal" persistent scrollable>
        <v-card class="kbLight">
            <v-toolbar class="kbPink" dark flat>
                <div class="text-h6">{{ $t('general.editList') }}</div>
                <v-spacer></v-spacer>
                <v-btn icon @click="toggleModal(false)">
                    <v-icon>clear</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-form v-model="validListPersons" ref="editListPersonsForm" lazy-validation>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field :label="$t('general.name')"
                                          color="kbDarkBlueText"
                                          v-model="formListPersons.name"
                                          :rules="[rules.required]">
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red"
                       outlined
                       @click="toggleModal(false)">{{ $t('general.cancel') }}</v-btn>
                <v-btn color="kbPink"
                       dark
                       :loading="updatingListPersons"
                       @click="submit">{{ $t('general.saveChanges') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import notifications from '@/libs/notifications'
import rules from '@/libs/rules'
export default {
  data () {
    return {
      updatingListPersons: false,
      validListPersons: false,
      formListPersons: {
        name: ''
      },
      rules
    }
  },
  methods: {
    submit () {
      if (!this.$refs.editListPersonsForm.validate()) return
      this.updatingListPersons = true
      this.$store.dispatch('updateSpecificList', {
        listId: this.listPersons,
        name: this.formListPersons.name
      }).then(() => {
        notifications.success(this.$t('general.listCorrectlyUpdated'))
        this.$store.dispatch('getListsPersons')
        this.updatingListPersons = false
        this.toggleModal(false)
      }).catch(error => {
        notifications.error(error.message)
        this.updatingListPersons = false
      })
    },
    toggleModal (value) {
      this.showChangePassword = false
      this.$refs.editListPersonsForm.reset()
      this.$emit('clearSelectedListPersons')
      this.$emit('input', value)
    }
  },
  props: ['listPersons', 'value'],
  watch: {
    listPersons (listPersons) {
      if (this.value && listPersons) {
        this.$store.dispatch('getSpecificList', { listId: listPersons }).then(response => {
          this.formListPersons.name = response.list.name
        }).catch(error => {
          notifications.error(error.message)
        })
      }
    }
  }
}
</script>
